/**
 *
 * Asynchronously loads the component for SignupPage
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
